 
/**

 * @param {String} providedString - String. (Mandatory) The string containing the elements you want to be replaced.
 *
 * @returns {String} New string with replaced elements.
 */

export default (providedString = '') => {
  const regex = /§(.*?)§/g;

  return providedString?.replaceAll(regex, (_, value) => {
    return `<span class="chip" style="min-width: unset; cursor: pointer;" onclick="changValueDialog(this)"><span class="internal-span"><span class='chipText'>${value}</span></span></span>`;
  });
};
